export const SnapshotIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12 8v4l2 2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const CloneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M13.334 5.333H6.667c-.737 0-1.333.597-1.333 1.334v6.666c0 .737.596 1.334 1.333 1.334h6.667c.736 0 1.333-.597 1.333-1.334V6.667c0-.737-.597-1.334-1.333-1.334Z"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.667 10.667c-.734 0-1.334-.6-1.334-1.334V2.667c0-.734.6-1.334 1.334-1.334h6.666c.734 0 1.334.6 1.334 1.334"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const RestoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M1.418 8A6.582 6.582 0 1 0 8 1.418a7.13 7.13 0 0 0-4.929 2.004L1.418 5.075"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M1.418 1.418v3.657h3.657"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clip-path="url(#a)">
      <path
        stroke="#FF695E"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.4"
        d="M2.667 4.667h10.666"
      />
      <path
        stroke="#FF695E"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m3.333 4.667.667 8A1.333 1.333 0 0 0 5.333 14h5.334A1.334 1.334 0 0 0 12 12.667l.667-8M6 4.667v-2A.667.667 0 0 1 6.667 2h2.666a.667.667 0 0 1 .667.667v2"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const PencilIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 12 12"
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M10.587 3.406a1.409 1.409 0 1 0-1.993-1.993L1.921 8.087a1 1 0 0 0-.25.415l-.66 2.176a.25.25 0 0 0 .311.311l2.176-.66a1 1 0 0 0 .415-.248l6.674-6.675ZM7.5 2.5l2 2"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
